import type { SearchConfiguration } from '@backmarket/http-api/src/api-specs-search-reco/search/searchConfiguration'
import { filtersToWhereClause } from '@backmarket/nuxt-layer-recommendation/filtering/filtersToWhereClause'

const DEFAULT_FACETS = ['price', 'page', 'q', 'sort']

export function buildSearchRequestOptions({
  configuration,
  indexQueryParams,
  filtersInput,
  priceInput,
  pageInput,
  isBuybackEnabled,
}: {
  configuration: SearchConfiguration
  indexQueryParams: SearchConfiguration['indexes']['active']['queryParams']
  filtersInput: Record<string, string[]>
  priceInput: [number, number] | undefined
  pageInput: number
  isBuybackEnabled: boolean
}) {
  const sidebarFacets = configuration.facets.map(({ name }) => name)
  const priceFacets =
    configuration.priceFacet?.scales.map((facet) => facet.facetName) ?? []

  return {
    ...indexQueryParams,
    filters: filtersToWhereClause(filtersInput, configuration.complexFilter),
    facets: [...DEFAULT_FACETS, ...sidebarFacets, ...priceFacets],
    ...(priceInput && {
      numericFilters: [`price>=${priceInput[0]}`, `price<=${priceInput[1]}`],
    }),
    page: pageInput - 1,
    hitsPerPage: isBuybackEnabled ? 31 : 32,
  }
}
